// TODO some of these should be moved to styleguide
export default [
  {
    path: '/apply',
    name: 'apply',
    component: () => import('@/pages/Apply.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/register/:locale?',
    name: 'registration',
    component: () => import('@/pages/registration/Registration.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/pages/error/error-404',
    name: 'error-404',
    component: () => import('./error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/pages/error/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('./error/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      unused: true,
    },
  },
  {
    path: '/pages/login',
    name: 'auth-login',
    component: () => import('@/pages/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/account-setting',
    name: 'pages-account-setting',
    component: () => import('@/pages/account-setting/AccountSetting.vue'),
    meta: {
      pageTitle: 'Account Settings',
      resource: 'Auth',
      action: 'write',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Account Settings',
          active: true,
        },
      ],
    },
  },
  {
    path: '/services/tuberculosis-survey/:id',
    name: 'services-tuberculosis-survey',
    component: () => import('@/pages/tuberculosis-survey/Main.vue'),
    meta: {
      layout: 'full',
      action: 'read',
    },
  },
]
